import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root',
})
export class CustomDateSearchAdapter extends NativeDateAdapter {
  private static readonly DEFAULT_LOCALE ='en';
  private static readonly DEFAULT_TIMEZONE = 'Asia/Phnom_Penh'; // Set your timezone here

  private readonly dayNamesByLocale: { [key: string]: string[] } = {
    en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    ch: ['日', '一', '二', '三', '四', '五', '六'],
    kr: ['일', '월', '화', '수', '목', '금', '토'],
    jp: ['日', '月', '火', '水', '木', '金', '土'],
  };

  private readonly monthNamesByLocale: { [key: string]: string[] } = {
    en: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ],
    ch: [
      '一月', '二月', '三月', '四月', '五月', '六月',
      '七月', '八月', '九月', '十月', '十一月', '十二月',
    ],
    kr: [
      '1월', '2월', '3월', '4월', '5월', '6월',
      '7월', '8월', '9월', '10월', '11월', '12월',
    ],
    jp: [
      '1月', '2月', '3月', '4月', '5月', '6月',
      '7月', '8月', '9月', '10月', '11月', '12月',
    ],
  };

  constructor(platform: Platform) {
    super(CustomDateSearchAdapter.DEFAULT_LOCALE, platform);
  }

  /**
   * Returns the month names for the current locale.
   */
  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = this.locale || CustomDateSearchAdapter.DEFAULT_LOCALE;
    return this.monthNamesByLocale[locale] || this.monthNamesByLocale[CustomDateSearchAdapter.DEFAULT_LOCALE];
  }

  /**
   * Returns the day names for the current locale.
   */
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = this.locale || CustomDateSearchAdapter.DEFAULT_LOCALE;
    const dayNames = this.dayNamesByLocale[locale] || this.dayNamesByLocale[CustomDateSearchAdapter.DEFAULT_LOCALE];

    if (style === 'long') {
      return dayNames.map((_, index) => this.getFullDayName(index, locale));
    }
    return dayNames;
  }

  /**
   * 
   * @param date 
   * @param format
   * @returns
   */
  override format(date: Date, displayFormat: Object): string {
    const locale = this.locale || CustomDateSearchAdapter.DEFAULT_LOCALE;
    const monthNames = this.monthNamesByLocale[locale] || this.monthNamesByLocale[CustomDateSearchAdapter.DEFAULT_LOCALE];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  /**
   * Returns the full name of the day in the selected locale.
   */
  private getFullDayName(dayIndex: number, locale: string): string {
    const fullDayNames: { [key: string]: string[] } = {
      en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      ch: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      kr: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
      jp: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
    };

    return fullDayNames[locale]?.[dayIndex] || fullDayNames[CustomDateSearchAdapter.DEFAULT_LOCALE][dayIndex];
  }
}
